import { Component, OnInit } from '@angular/core';
import { MotdService } from 'src/app/modules/auth-client/services/motd.service';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {ArticleService} from '../../services/article.service';
import {ShoppingService} from '../../services/shopping.service';
import {NotifyService} from '../../../brover-notify/services/notify.service';
import {FilterService} from '../../services/filter.service';
import { UserService } from '../../../auth-client/services/user.service';

@Component({
    selector: 'brover-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.sass'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  public moment = moment;
  constructor(private motdService: MotdService, private router: Router, private articleService: ArticleService,
              public shoppingService: ShoppingService,  private notify: NotifyService, public filterService: FilterService, public userService: UserService) { }

  public messages = [];
  public orders = [];
  public tenders = [];

  ngOnInit() {
    this.updateDataSource();

    this.articleService.Orders(0, 4).subscribe(x => {
      this.orders = x.orders;
    });

    this.articleService.getCards(0, 4).subscribe(x => {
      console.log(x);
      this.tenders = x.carts;
    });
  }

  private updateDataSource() {
    this.motdService.getAllMotd(0, 10).subscribe(res => {
      this.messages = res['data']['messages'].sort(function(a, b) {
          a = new Date(a.from);
          b = new Date(b.from);
          return a > b ? -1 : a < b ? 1 : 0;
      });
    });
  }

  goTo(s: string, order = null) {
    if (order) {
      const copy = this.shoppingService.order;

      copy.deliverDate = order.delivery_date;
      copy.shoppingBag = [];
      order.items.forEach(x => {
        copy.shoppingBag.push({articleNumber: x.article, qty: x.qty});
      });
      copy.references = order.reference;
      copy.car_type = order.car_type;
      copy.brand = order.brand;

      copy.address = order.address;
      copy.place = order.place;
      copy.postal_code = order.postal_code;
      copy.tender = order.tender;
      copy.id = order.id;

      this.shoppingService.order = copy;

      this.router.navigate(['/', 'dashboard', s, order.id]);
    } else  {
      this.router.navigate(['', 'dashboard', s]);
    }

  }

  redoOrder(orderDetail) {
    const copy = this.shoppingService.order;

    copy.deliverDate = orderDetail.delivery_date;
    copy.shoppingBag = [];
    orderDetail.items.forEach(x => {
      copy.shoppingBag.push({articleNumber: x.article, qty: x.qty});
    });
    copy.references = orderDetail.reference;
    copy.car_type = orderDetail.car_type;
    copy.brand = orderDetail.brand;

    copy.address = orderDetail.address;
    copy.place = orderDetail.place;
    copy.postal_code = orderDetail.postal_code;
    copy.tender = orderDetail.tender;
    copy.id = orderDetail.id;

    this.filterService.brand = orderDetail.brand;
    this.filterService.type = orderDetail.car_type;

    this.shoppingService.order = copy;
    this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', false]);
  }

  public deleteCard(id: number) {
    if (confirm('Weet je zeker dat je dit deze opgeslagen order wilt verwijderen')) {
      this.articleService.deleteCard(id).subscribe(() => {
        this.notify.success('Opgeslagen order verwijderd');
        this.articleService.getCards(0, 4).subscribe(x => {
          this.tenders = x.carts;
        });
      });
    }
  }

  public orderNow(orderDetail: any) {
    console.log(orderDetail);
    this.shoppingService.clearOrder();
    const copy = this.shoppingService.order;

    copy.shoppingBag = [];
    orderDetail.items.forEach(x => {
      copy.shoppingBag.push({articleNumber: x.articleNumber, qty: x.qty});
    });
    copy.references = orderDetail.reference;
    copy.car_type = orderDetail.car_type;
    copy.brand = orderDetail.brand;
    copy.tender = orderDetail;
    this.shoppingService.order = copy;


    this.filterService.brand = orderDetail.brand;
    this.filterService.type = orderDetail.car_type;

    // tslint:disable-next-line: max-line-length
    this.router.navigate(['/', 'dashboard', 'place-order', 'overview', 'ordered', false], { queryParams: { from: 'tenders', tenderId: orderDetail['id'] } });
  }
}
